export const wellnessFormat = (arr) =>
  arr.map((d) => ({ ...d, isWellness: true }));

const sorted = (arr) => [...arr].sort((a, b) => a.order_id - b.order_id);

const withMarkerType = (arr, markerType) =>
  (arr || []).map((d) => ({ ...d, markerType }));

export const formatMarkers = (data) => {
  const perc = withMarkerType(data.vas, "vas");
  const scale = withMarkerType(data.scale, "scale");
  const quanti = withMarkerType(data.indicator, "quanti");
  const duration = withMarkerType(data.duration, "duration");
  const bool = withMarkerType(data.boolean, "bool");
  const mcq = withMarkerType(data.mcq, "mcq");
  const qst = withMarkerType(data.question, "qst");

  const all = [
    ...perc,
    ...scale,
    ...quanti,
    ...duration,
    ...bool,
    ...mcq,
    ...qst,
  ];

  return {
    sorted: sorted(all),
    perc: sorted(perc),
    scale: sorted(scale),
    quanti: sorted(quanti),
    duration: sorted(duration),
    bool: sorted(bool),
    mcq: sorted(mcq),
    qst: sorted(qst),
  };
};
